module.exports = __webpack_public_path__ + "img/instagram.56ad916d.png";